module.exports = __webpack_public_path__ + "img/20200613_093815.a0b8b99b.jpg";